'use client';

import Image from 'next/image';
import { features, featuresTitle } from '@src/constants';
import { useScrollContext } from '@src/context/scroll-context';
import Seperator from '../icons/Seperator';
import CubeIcon from '../icons/cubeIcon';
import GreenCheck from '../icons/GreenCheck';

export default function Features() {
  const { featuresRef } = useScrollContext();
  return (
    <section
      ref={featuresRef}
      aria-labelledby="features-heading"
      className="flex w-full flex-col gap-y-24 overflow-clip py-[60px] max-2xl:px-2 max-md:px-5 sm:py-[120px]"
    >
      {/* The section has three per-feature headings but no heading of its own,
          and the design has no room for one: each block already carries an
          "OUR FEATURES" eyebrow. Visually hidden rather than absent, so the
          three h3s below sit under an h2 instead of directly under the h1. */}
      <h2 id="features-heading" className="sr-only">
        {featuresTitle}
      </h2>
      {features.map((feature) => (
        <div
          className="flex w-full flex-col justify-center gap-x-5 md:flex-row"
          key={feature.title}
        >
          <div className="flex flex-col sm:w-[406px]">
            <div>
              <div className="flex items-center gap-2">
                <CubeIcon color="#6106FF" />
                <p className="tiny-text purple-gradient-text font-bold uppercase">
                  Our Features
                </p>
                <Seperator color="white" />
                <p className="body14-responsive font-medium">
                  {feature.subTitle}
                </p>
              </div>
            </div>
            {/* Was a <p> carrying heading-sized type. The homepage shipped no
                h2-h6 at all, so nothing below the h1 was a heading. */}
            <h3 className="h36-responsive mt-1 font-bold">{feature.title}</h3>
            <p className="body16 mt-5 font-medium">{feature.description}</p>
            <div className="mt-5 flex items-center gap-1">
              <GreenCheck />
              <p className="body16 font-medium">{feature.keySentence}</p>
            </div>
          </div>
          {/* Was a div with an inline `style={{ backgroundImage }}`, which put
              a 300 KB PNG outside next/image entirely: no webp, no srcset and
              no lazy loading for three images below the fold. The explicit
              width/height match the asset's intrinsic size, so the desktop
              box still renders it unscaled and top-right aligned exactly as
              `bg-auto bg-right-top bg-no-repeat` did. */}
          {/* `items-start`, not the flex default: a stretched flex item took
              the image to the box's full 616px height and distorted it. */}
          <div className="flex h-[616px] w-[720px] items-start justify-end max-md:mt-8 max-md:h-[524px] max-md:w-[392px]">
            <Image
              src={feature.image}
              alt={feature.title}
              width={686}
              height={480}
              sizes="(max-width: 768px) 392px, 686px"
              loading="lazy"
              className="max-md:h-full max-md:w-full max-md:object-cover max-md:object-center"
            />
          </div>
        </div>
      ))}
    </section>
  );
}
